export enum ChatTypeEnum {
  GC = 0,
  PERSONAL = 1
}
